import { colors, fontSizes, fontWeights, lineHeights, spacings, responsiveBreakPoints } from '@styles/DesignVariables';
import styled from 'styled-components';
const { maxTablet } = responsiveBreakPoints;

export const TrustRatingWrapper = styled.div<{ marginBottom?: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-bottom: ${({ marginBottom }) => marginBottom || spacings.s16};
	@media screen and (${maxTablet}) {
		margin-bottom: 0px;
	}
`;

export const TrustRatingText = styled.p`
	color: ${colors.greyTitle};
	text-align: center;
	font-size: 14px;
	font-weight: ${fontWeights.bold};
	line-height: 18px;
	margin-bottom: 0 !important;
`;

export const TrustRatingScore = styled.h4`
	color: ${colors.greyTitle};
	font-size: ${fontSizes.trustHeading};
	font-weight: ${fontWeights.bold};
	line-height: ${lineHeights.trustHeading};
`;

export const TrustRatingBar = styled.div`
	margin: ${spacings.s4} 0;
`;

export const TrustRatingEvaluation = styled.p`
	color: ${colors.darkGrey};
	font-size: 14px;
	font-weight: ${fontWeights.semibold};
	line-height: 18px;
	margin-bottom: 2px !important;
`;

export const TrustRatingUsers = styled.p`
	color: ${colors.lightGrey};
	font-size: ${fontSizes.tinyParagraph};
	font-weight: ${fontWeights.normal};
	line-height: ${lineHeights.tinyParagraph};
	@media screen and (${maxTablet}) {
		text-align: center;
	}
`;
